require('./addBeneficiaryStep2.scss');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING , CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

// @ utilities
const { isSepa } = require('utilities/transfersHelper');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatIbanString } = require('commonsUtilities/stringHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @ constants
const {
    ADD_SEPA_BENEFICIARY_ID,
    ADD_NO_SEPA_BENEFICIARY_ID,
    EDIT_SEPA_BENEFICIARY_ID,
    EDIT_NO_SEPA_BENEFICIARY_ID
} = require('constants/operationTypes');
const { BENEFICIARY_BANK_OPTION_BIC, HYPHEN } = require('constants/index');
const { getTranslatedCountry } = require('constants/countries');


class AddBeneficiaryStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getOperationId() {
        const { immAddBeneficiary, beneficiaryId } = this.props;
        const isEditing = !!beneficiaryId;
        const isSepaType = isSepa(
            immAddBeneficiary.get('country'),
            immAddBeneficiary.get('currency')
        );

        if (isEditing) {
            return isSepaType ? EDIT_SEPA_BENEFICIARY_ID : EDIT_NO_SEPA_BENEFICIARY_ID;
        }

        return isSepaType ? ADD_SEPA_BENEFICIARY_ID : ADD_NO_SEPA_BENEFICIARY_ID;
    }

    buildAccountBankDetail(immAddBeneficiary, accountTitle, account) {
        const accountItem = this.buildIbanAccountItem(accountTitle, account);
        return (
            <OKInformativeList columns={2}>
                {accountItem}
                <OKInformativeListItem
                    title={'transferSummary-step1BeneficiaryBankName'}
                    bodyText={immAddBeneficiary.get('bankName')}
                />
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryBankAddress"
                    bodyText={immAddBeneficiary.get('bankAddress')}
                />
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryBankCity"
                    bodyText={immAddBeneficiary.get('bankCity')}
                />
            </OKInformativeList>
        );
    }

    buildAccountBic(immAddBeneficiary, accountTitle, account) {
        const { immBankEntity } = this.props;
        const accountItem = this.buildIbanAccountItem(accountTitle, account);
        const bankName = immBankEntity.get('bankName') || HYPHEN;

        const bicSection = [(
            <div key={`addBeneficiaryStep2-bic`}>
                {immAddBeneficiary.get('bic')}
            </div>
        ),(
            <div key={`addBeneficiaryStep2-bank-entity`}>
                ({bankName})
            </div>
        )];

        return (
            <OKInformativeList columns={2}>
                {accountItem}
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryBic"
                    isUppercaseTitle={true}
                    onlyChildren={true}
                >
                    {bicSection}
                </OKInformativeListItem>
            </OKInformativeList>
        );
    }

    buildCountryAndCurrency(immAddBeneficiary) {
        return (
            <OKInformativeList columns={2}>
                <OKInformativeListItem
                    title={'transferSummary-step1BeneficiaryCountryDestiny'}
                    bodyText={getTranslatedCountry(immAddBeneficiary.get('country'))}
                />
                <OKInformativeListItem
                    title="transferSummary-step1Currency"
                    bodyText={formatText('currency-' + immAddBeneficiary.get('currency'))}
                />
            </OKInformativeList>
        );
    }

    buildIban(iban) {
        const ibanTitle = formatText('transferSummary-step1BeneficiaryIBANAccount');
        const ibanBlock = this.buildIbanBlock(iban);

        return (
            <OKInformativeList>
                <OKInformativeListItem
                    title={ibanTitle}
                    onlyChildren={true}
                >
                    {ibanBlock}
                </OKInformativeListItem>
            </OKInformativeList>
        );
    }

    buildIbanAccountItem(ibanAccountTitle, ibanAccount) {
        return (
            <OKInformativeListItem
                title={ibanAccountTitle}
                bodyText={formatIbanString(ibanAccount)}
            />
        );
    }

    buildIbanBlock(ibanAccount) {
        const { immBankEntity } = this.props;
        const bankName = immBankEntity.get('bankName') || HYPHEN;

        const ibanSection = [(
            <div key={`addBeneficiaryStep2-iban`}>
                {formatIbanString(ibanAccount)}
            </div>
        ),(
            <div key={`addBeneficiaryStep2-bank-entity`}>
                ({bankName})
            </div>
        )];

        return ibanSection;
    }

    buildNameAndAlias(immAddBeneficiary) {
        return (
            <OKInformativeList columns={2}>
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryName"
                    bodyText={immAddBeneficiary.get('name')}
                />
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryAlias"
                    bodyText={immAddBeneficiary.get('alias')}
                />
            </OKInformativeList>
        );
    }

    buildOutsideSepaSection(immAddBeneficiary) {
        return (
            <OKInformativeList columns={2}>
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryAddress"
                    bodyText={immAddBeneficiary.get('address') || HYPHEN}
                />
                <OKInformativeListItem
                    title="transferSummary-step1BeneficiaryCity"
                    bodyText={immAddBeneficiary.get('city') || HYPHEN}
                />
            </OKInformativeList>
        );
    }

    buildSubtitle() {
        const { immAddBeneficiary, beneficiaryId } = this.props;
        const isEditing = !!beneficiaryId;
        let key;

        if (isEditing) {
            key = 'addBeneficiary-step2EditSubtitleLabel';
        } else {
            key = 'addBeneficiary-step2AddSubtitleLabel';
        }
        return (
            <label className="add-beneficiary-step-two__label">
                <FormattedText value={key} injectedStrings={[immAddBeneficiary.get('alias')]} />
            </label>
        );
    }

    render() {
        const { immAddBeneficiary, beneficiaryId } = this.props;
        const ibanOrAccount =  immAddBeneficiary.get('iban') || immAddBeneficiary.get('accountNumber');
        const isInsideSepa = isSepa(immAddBeneficiary.get('country'), immAddBeneficiary.get('currency'));
        const confirmationTitleClassName = contactCenterClassName('print-title', 'add-beneficiary-step-two__header');

        const operationParams = {
            ammount: 1,
            currency: immAddBeneficiary.get('currency'),
            destinationAccount: ibanOrAccount,
            optional1: immAddBeneficiary.get('alias')
        };
        const operationId = this.getOperationId();
        const subtitle = this.buildSubtitle();
        const nameAndAlias = this.buildNameAndAlias(immAddBeneficiary);
        const countryAndCurrencyContent = this.buildCountryAndCurrency(immAddBeneficiary);
        const operative = beneficiaryId ? formatText('operatives-modifyBeneficiary') : formatText('operatives-addNewBeneficiary');
        let outsideSepaContent;
        let bankAccountContent;
        if (isInsideSepa) {
            bankAccountContent = this.buildIban(ibanOrAccount);
        } else {
            const accountTitle = formatText('transferSummary-step1BeneficiaryAccountNumber');
            outsideSepaContent = this.buildOutsideSepaSection(immAddBeneficiary);
            if (immAddBeneficiary.get('bankOption') === BENEFICIARY_BANK_OPTION_BIC) {
                bankAccountContent = this.buildAccountBic(
                    immAddBeneficiary,
                    accountTitle,
                    ibanOrAccount
                );
            } else {
                bankAccountContent = this.buildAccountBankDetail(
                    immAddBeneficiary,
                    accountTitle,
                    ibanOrAccount
                );
            }
        }

        return (
            <article className="add-beneficiary-step-two">
                <header className={confirmationTitleClassName}>
                    <FormattedText value="addBeneficiary-step2Title" />
                </header>

                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                </ContactCenterRender>

                <section className="add-beneficiary-step-two__content">
                    {subtitle}
                    {nameAndAlias}
                    {outsideSepaContent}
                    {countryAndCurrencyContent}
                    {bankAccountContent}
                </section>
                <section className="add-beneficiary-step-two__signature">
                    
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>

                    <SignaturePattern
                        operationType={operationId}
                        operationParams={operationParams}
                    />
                </section>
            </article>
        );
    }
}

AddBeneficiaryStep2.propTypes = {
    immAddBeneficiary: PropTypes.object.isRequired,
    immBankEntity: PropTypes.object.isRequired,
    beneficiaryId: PropTypes.string
};

module.exports = AddBeneficiaryStep2;
